import {useQuery} from '@tanstack/react-query'
import {useUser} from 'features/authorized/context/user'
import {UserData} from 'features/common/core/entitites'
import {useTranslation} from 'react-i18next'
import downloadImage from '../../utils/downloadImage'
import getQRCards from './api/getQRCard'

const useQRCards = () => {
    const {user} = useUser() as {user: UserData}
    const {i18n} = useTranslation()
    const {data, isFetching} = useQuery(['qrCards', i18n.language], () =>
        getQRCards({language: i18n.language, qrId: user.organization.qrId}),
    )

    const onDownload =
        ({
            cardData,
            cardName,
        }: {
            cardData: string | undefined
            cardName: string
        }) =>
        () => {
            if (!cardData) {
                return
            }
            downloadImage({data: cardData, name: cardName})
        }
    const onDownloadCard = onDownload({
        cardData: data?.card,
        cardName: 'qrCard',
    })
    const onDownloadSticker = onDownload({
        cardData: data?.sticker,
        cardName: 'qrSticker',
    })
    const onDownloadTabletop = onDownload({
        cardData: data?.tabletop,
        cardName: 'qrTabletop',
    })

    return {
        data,
        onDownloadCard,
        onDownloadSticker,
        onDownloadTabletop,
        isLoading: isFetching,
    }
}

export default useQRCards
